import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getTrialSettings() {
	return sendRequestWithAuth(settings.ServerURL, {
		method: 'POST',
		body: JSON.stringify({
			operation: 'get_trial_settings',
		}),
	});
}

export function getTrialSettingsHistory(settingsId = 1) {
	return sendRequestWithAuth(settings.ServerURL, {
		method: 'POST',
		body: JSON.stringify({
			operation: 'get_trial_settings_history',
			trial_settings_id: settingsId,
		}),
	});
}

export function getTrialSettingsHistoryById(id) {
	return sendRequestWithAuth(settings.ServerURL, {
		method: 'POST',
		body: JSON.stringify({
			operation: 'get_trial_settings_history_by_id',
			id: id,
		}),
	});
}

export function editTrialSettings(id = 1, minAllowedViewerVersion, onceAYear) {
	return sendRequestWithAuth(settings.ServerURL, {
		method: 'POST',
		body: JSON.stringify({
			operation: 'edit_trial_settings',
			id: id,
			min_allowed_viewer_version: minAllowedViewerVersion,
			once_a_year: onceAYear,
		}),
	});
}



// WEBPACK FOOTER //
// ./src/services/trialSettings.js